import "./creationMeter.css";

export default function CreationMeter({
    humanPercent = 100,
    humanLabel = "Hand-Drawn",
    aiLabel = "AI-Generated",
}) {
    const aiPercent = 100 - humanPercent;

    return (
        <div className="creation-meter">
            <div className="creation-meter-track">
                <div
                    className="creation-meter-human-fill"
                    style={{ width: `${humanPercent}%` }}
                ></div>
            </div>

            <div className="creation-meter-values">
                <span>
                    {humanPercent}% {humanLabel}
                </span>

                <span>
                    {aiPercent}% {aiLabel}
                </span>
            </div>
        </div>
    );
}